import React from 'react';

function Marquee() {
  return (
    <section className="marquee-skew">
      <div className="container-fluid rest">
        <div className="row">
          <div className="col-12">
            <div className="main-marq lrg">
              <div className="slide-har st1">
                <div className="box non-strok">
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>UI-UX Experience</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Web Development</span>{' '}
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Digital Marketing</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Product Design</span>{' '}
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Mobile Solutions</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                </div>
                <div className="box non-strok">
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>UI-UX Experience</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Web Development</span>{' '}
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Digital Marketing</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Product Design</span>{' '}
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Mobile Solutions</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Marquee;
